/** 支付相关接口 */
import request from '@/utils/util.request';

/*
 *  (wxpay) 微信支付页面，加载数据
 *  @param {int} wx_payment_id: 来跳转前一个页面的值
 *  @param {string} url：当前页面的完整url
 */
export const wxpay_load_data = (data) => {
	return request({
		url: '/wxpay/loaddata',
		data,
	});
};

/*
 *  (wxpay) 微信支付完成后，通知服务端
 *  @param {int} wx_payment_id:
 *  @param {String} result: success | cancel | fail
 *  @param {String | null} err_msg: ('chooseWXPay:ok')
 */
export const wxpay_paid = (data) => {
	return request({
		url: '/wxpay/paid',
		data,
	});
};
